<template>
    <CModal
        class="modal-stretch SignInModal"
        data-test-id="signInModal"
        :hide-closer="isLoading"
        :prevent-backdrop-click="isLoading"
        :title="isResetPassword ? 'Zabudnuté heslo' : 'Prihlásenie'"
        :model-value="true"
        @update:model-value="handleClose"
    >
        <div :key="keyRenderForm">
            <CText v-if="message && !isResetPassword" class="mb-4 block sm:mb-5" variant="muted">
                <span v-html="message"></span>
            </CText>
            <AuthForm
                auth-method="signInWithEmailAndPassword"
                button-label="Prihlásiť sa"
                class="mb-4"
                v-model:loading="isLoading"
                :redirect="route.fullPath"
                v-model:reset-password="isResetPassword"
            />
            <div class="text-center">
                <template v-if="isResetPassword">
                    <CButton href="javascript:void(0)" icon="back" variant="link" @click="goBack()">
                        Späť na prihlásenie
                    </CButton>
                </template>
                <template v-else>
                    Nemáš účet?
                    <NuxtLink class="link" :to="{ name: 'auth-create-account' }"> Registruj sa</NuxtLink>.
                </template>
            </div>
        </div>
    </CModal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
    message: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['close'])

const isLoading = ref(false)
const isResetPassword = ref(false)
const keyRenderForm = ref(1)
const route = useRoute()

watch(
    () => route.path,
    () => {
        emit('close')
    }
)

const handleClose = (value: boolean) => {
    if (!value && !isLoading.value) {
        emit('close')
    }
}

const goBack = () => {
    isResetPassword.value = !isResetPassword.value
    keyRenderForm.value += 1
}
</script>
